import { render, staticRenderFns } from "./ExternalAccountBalanceWidget.vue?vue&type=template&id=01da57fc"
import script from "./ExternalAccountBalanceWidget.vue?vue&type=script&lang=js"
export * from "./ExternalAccountBalanceWidget.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports